
'use strict';
import util from '../util';

function getAllH2Tags(isDesktop){
    const tags = {};
    const diff = isDesktop ? 160 : 100
    $($('.blog-pages')[0]).find('h2').not("#minimized-header-container h2").each((idx,tag) => {
        if (idx === 0){
            tags[0] = $(tag).text();
        }
        let topKey = Math.floor($(tag).offset().top ) -  diff
        tags[topKey] = tags[topKey] ?? $(tag).text();

    });
    return tags;
}

var blogPages = {
    /**
     *
     */
    init: function () {
        $(document).on('click', '.read-next-links', function (e) {
            e.stopPropagation();
            var readHref = $(this).data('href');
            if (readHref !== '') {
                window.location.href = readHref;
            }
        });
        const totalSlides = $('.emea-slick-slider .recommendation-item').length;
        const $emeaSlider = $('.emea-slick-slider');
        const $emeaSliderCenter = 'emea-slider-center';
        const $emeaSliderCenterDesktop = 'emea-slider-center-desktop';
        const $emeaSliderCenterMobile = 'emea-slider-center-mobile';
        if ($(window).innerWidth() > 767) {
            if(totalSlides > 4) {
                $emeaSlider.removeClass($emeaSliderCenter);
                $emeaSlider.slick({
                    dots: false,
                    focusOnSelect: false,
                    infinite: false,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    variableWidth: true,
                    speed: 300
                });
            } else {
                $emeaSlider.addClass($emeaSliderCenter);
            }
        } else {
            // added to handle mobile devices
            $emeaSlider.addClass('slick-mobile-flex');
            if(totalSlides <=2 ) {
                $emeaSlider.addClass($emeaSliderCenter);
            } else {
                $emeaSlider.removeClass($emeaSliderCenter);
            }
        }
        
        // added to handle preview mode
        if ($(window).innerWidth() == 0) {
            $emeaSlider.removeClass($emeaSliderCenter);
            if(totalSlides <= 2){
                $emeaSlider.addClass($emeaSliderCenterMobile);
                $emeaSlider.addClass($emeaSliderCenterDesktop);
            } else if(totalSlides <= 5) {
                $emeaSlider.addClass($emeaSliderCenterDesktop);
            } else {
                $emeaSlider.removeClass($emeaSliderCenterDesktop);
                $emeaSlider.removeClass($emeaSliderCenterMobile);
            }
        }

        $(document).ready(function () {
            $('.topics-row .active').each(function(e){
                if(!$('.topics-row').hasClass('slick-slider')){
                    var folderID = $(this).data('folderid');
                    var folderName = $(this).data('folder-name');
                    var folderUrl = util.appendParamsToUrl(Urls.blogShowAjax, {
                        folderID: folderID,
                        format: 'ajax'
                    });
                    toggleTopicsRowSlick(true);
                    $('.topics-wrapper .topics-heading').text("Topic:" + $(this).data('folder-name'));
                    $(".topics-page-wrapper .breadcrumb .breadcrumb-element:last").text("Topic:" + $(this).data('folder-name'));
                    var goto = $(this).data("slick-index");
                    $(".topics-page-wrapper .topics-wrapper .topics-row").slick("slickGoTo",goto, true);
                    $.ajax({
                        url: folderUrl,
                        method: 'GET',
                        dataType: 'json',
                        success: function (data) {
                            if (data.contentObject.length >= 1) {
                                $('#ajaxFolderContentData').empty();
                                for (var i=0; i<data.contentObject.length; i++) {
                                    var articleUrl = util.appendParamsToUrl(Urls.pageShow, {
                                        cid: data.contentObject[i].ID
                                    });
                                    $(`<div data-href='${articleUrl}' class='small-article-block-wrapper no-after read-next-links two-column col-md-6 d-inline-block'>
                                        <div class='thumbnail'>
                                            <img src='${data.contentObject[i].displayImageOnBlogPage}' alt='Article Image'>
                                        </div>
                                        <div class='content no-after'>
                                            <div class="hero-categories">
                                                <div class="category" style="background:${data.contentObject[i].catColor}">${data.contentObject[i].categoryLinkOnBlogPage} </div>
                                            </div>
                                            <h2 class='title font-fam-LibreBold'>${data.contentObject[i].displayHeadingOnBlogPage}</h2>
                                            <div class='summary'>${data.contentObject[i].displaySummaryOnBlogPage}
                                            <div class='read-article'>
                                                ${Resources.READ_ARTICLE}
                                                <img src='${Urls.rightArrow}' />
                                            </div>
                                        </div>
                                    </div>
                                    `).appendTo('#ajaxFolderContentData');
                                }
                                $('#ajaxFolderContentData').css("display", "flex");
                                $('#allTopicTile').css("display", "none");
                                $('.all-topic-tile-wrapper-heading').css("display", "none");
                            }
                            else{
                                $('#ajaxFolderContentData').empty();
                            }
                        },
                        error: function (data) {
                            $('#ajaxFolderContentData').empty();
                        },
                    })
                }
            })
            //image slider starts
            var slidesToShowDesktop = $('.blog-image-slider-wrapper').data('slides-to-show-desktop');
            var slidesToShowMobile = $('.blog-image-slider-wrapper').data('slides-to-show-mobile');
            var slidesToScrollDesktop = $('.blog-image-slider-wrapper').data('slides-to-scroll-desktop');
            var slidesToScrollMobile = $('.blog-image-slider-wrapper').data('slides-to-scroll-mobil');
            var showSliderDesktop = $('.blog-image-slider-wrapper').data('show-carousel-bar');
            var showSliderModile = $('.blog-image-slider-wrapper').data('show-carousel-bar-mobile');
            var autoPlayDesktop = $('.blog-image-slider-wrapper').data('show-carousel-autoplay');
            var autoPlayMobile = $('.blog-image-slider-wrapper').data('show-carousel-autoplay-mobile');
            $('.blog-image-slider').slick({
                infinite: true,
                slidesToShow: slidesToShowDesktop,
                slidesToScroll: slidesToScrollDesktop,
                slide: 'li',
                dots: showSliderDesktop,
                arrows: true,
                centerMode: true,
                variableWidth: true,
                autoplay: autoPlayDesktop,
                autoplaySpeed: 4000,
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: slidesToShowMobile,
                            slidesToScroll: slidesToScrollMobile,
                            infinite: true,
                            dots: showSliderModile,
                            centerMode: true,
                            autoplay: autoPlayMobile,
                            arrows: false
                        }
                    }
                ]
            });
            setTimeout(()=>{
                var topMargin = $(".blog-image-slider").find(".blog-image-slide-item picture").height()-12;
                $('.blog-image-slider').find(".slick-dots").css("top", topMargin+"px");
                const blogImageLen = $('.blog-image-slider').find('.slick-dots').find('li').length;
                var blogImageSlider = ($(".blog-image-slider").find(".blog-image-slide-item picture").width())/blogImageLen
                $('.blog-image-slider').find('.slick-dots li').each(function(){
                $(this).css("width", blogImageSlider-10+"px");
            });
            }
            ,1000)
            //image slider ends

            // topics progression slider
            var widthTopics=0;
            $('.browse-our-topics').find('.experience-blog_assets-topicTile').each(function(i,val){
                widthTopics+=$(val).width();
            });
            widthTopics= widthTopics + 72;
            if ($(window).width() <=767 && $(window).width() < widthTopics){
                $('.experience-topics').slick({
                    dots: true,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll:1,
                    variableWidth: true,
                    arrows:false,
                });
            }

            // Browse categories slider starts here
            var widthCatTiles=0;
            var slideActiveColor;
            $(".experience-categoryTiles").each(function(i,val){
                $(this).find(".experience-blog_assets-articleTile").each(function(i,val){
                    widthCatTiles+=$(val).width();
                });
                widthCatTiles= widthCatTiles + 156;
                if($(window).width() < widthCatTiles){
                    $(this).slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 1,
                        slidesToScroll:1,
                        variableWidth: true,
                        arrows:false,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                   dots: true
                                }
                            }
                        ]
                    });
                    $(this).on('swipe afterChange', function(event, slick, currentSlide, nextSlide){
                        slideActiveColor=$(this).closest(".browse-our-category").data("slide-active-color");
                        $(this).find(".slick-dots li.slick-active").css("border-top","2px solid"+slideActiveColor);
                        $(this).find(".slick-dots li:not(.slick-active)").css("border-top","");
                });
                slideActiveColor=$(val).closest(".browse-our-category").data("slide-active-color");
                $(val).find(".slick-dots li.slick-active").css("border-top","2px solid"+slideActiveColor);
                }
                widthCatTiles=0;
            });
            $(".browse-our-category").find('.slick-slider').closest('.list-container').removeClass('list-container justify-center');
            $('.slick-dots li').on('click',function(e){
                slideActiveColor=$(this).closest(".browse-our-category").data("slide-active-color");
                $(this).css("border-top","2px solid"+slideActiveColor);
                $(this).siblings().not('.slick-active').css("border-top","");
            });
            // Browse categories slider ends

            // Single product slider starts
            $('.product-content-image-slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
            });
            // Single product slider ends
            $('.product-content-image-slider .slick-dots').each(function(){
                const len = $(this).find('li').length;
                $(this).find('li').each(function(){
                    $(this).css("width", 90/len+"%")
                });
            });
            $('.experience-component .swatch-list').slick({
                infinite: true,
                slidesToShow: 18,
                slidesToScroll: 18,
                dots: false,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 10,
                            slidesToScroll: 10,
                        }
                    }
                ]
            });
        });
        // Full screen steps slider - MVP changes
        if($(window).width() > 767){
            $(".full-screen-steps-wrapper").slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToScroll: 1,
                variableWidth: true,
                arrows: true,
            });
        }

        // Topics List on Blog Page-----start
        $(document).ready(function(){
                if(typeof folderID == "undefined"){
                    var selectedTopic= $(".topics-row").find('.active').data("folderid")
                    var folderID = new Array();
                    if(typeof selectedTopic != "undefined"){
                        folderID.push(selectedTopic)
                    }
                }
            function toggleTopicActive(element, folderName) {
                if (element.hasClass("active")) {
                    element.removeClass("active");
                    var removeTopicIndex= folderID.indexOf(element.data('folderid'))
                    folderID.splice(removeTopicIndex,1);
                    if(folderID.length == 1){
                        var selectedFolderName=$('.topics-row').find('.active').data("folder-name")
                        $('.topics-wrapper .topics-heading').text("Topic:" + selectedFolderName);
                        $(".topics-page-wrapper .breadcrumb .breadcrumb-element:last").text("Topic:" + selectedFolderName);
                    }else{
                        $('.topics-wrapper .topics-heading').text("Topics");
                        $(".topics-page-wrapper .breadcrumb .breadcrumb-element:last").text("Topics");
                    }
                }
                else {
                    element.addClass("active");
                    if(element.closest('.topics-row').find('.active').length == 1){
                        $('.topics-wrapper .topics-heading').text("Topic:" + folderName);
                        $(".topics-page-wrapper .breadcrumb .breadcrumb-element:last").text("Topic:" + folderName);
                    }else{
                        $('.topics-wrapper .topics-heading').text("Topics");
                        $(".topics-page-wrapper .breadcrumb .breadcrumb-element:last").text("Topics");
                    }
                    if(folderID.indexOf(element.data('folderid')) == -1) {
                        folderID.push(element.data('folderid'))
                    }
                    if(!$('.topics-page-wrapper .topics-wrapper .topics-row').hasClass('slick-slider')){
                        toggleTopicsRowSlick(true);
                    }
                    var goto = element.data("slick-index")
                    goto? $(".topics-page-wrapper .topics-wrapper .topics-row").slick("slickGoTo",goto, true) : ''
                }
            }
            function toggleTopicsRowSlick(makeSlick) {
                if (makeSlick) {
                    $(".topics-page-wrapper .topics-wrapper .topics-row").slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToScroll: 1,
                        variableWidth: true,
                        arrows: false,
                    });
                }
                else {
                    $('.topics-page-wrapper .topics-wrapper .topics-row').slick('unslick');
                }

            }
            $(document).on('click', '.topic-name-wrapper', function (e) {
                e.stopImmediatePropagation();
                e.preventDefault();
                var folderName = $(this).data('folder-name');
                if ($(this).closest(".topics-row").find(".active").length > 0) {
                    toggleTopicActive($(this), folderName);
                }
                else {
                    toggleTopicActive($(this), folderName);
                }
                if(folderID.length > 0 && !$('.topics-page-wrapper .topics-wrapper .topics-row').hasClass('slick-slider')){
                    toggleTopicsRowSlick(true);
                }else if(folderID.length == 0){
                    toggleTopicsRowSlick(false);
                }
                var folderUrl = util.appendParamsToUrl(Urls.blogShowAjax, {
                    folderID: folderID,
                    format: 'ajax'
                });
                $('#allTopicTile').css("display", "none");
                $('.all-topic-tile-wrapper-heading').css("display", "none");
                if (folderID.length == 0) {
                    $('#allTopicTile').css("display", "flex");
                    $('.all-topic-tile-wrapper-heading').css("display", "block");
                    $('#ajaxFolderContentData').css("display", "none");
                }
                else {
                    $.ajax({
                        url: folderUrl,
                        method: 'GET',
                        dataType: 'json',
                        success: function (data) {
                            if (data.contentObject.length >= 1) {
                                $('#ajaxFolderContentData').empty();
                                for (var i=0; i<data.contentObject.length; i++) {
                                    var articleUrl = util.appendParamsToUrl(Urls.pageShow, {
                                        cid: data.contentObject[i].ID
                                    });
                                    $(`<div data-href='${articleUrl}' class='small-article-block-wrapper no-after read-next-links two-column col-md-6 d-inline-block'>
                                        <div class='thumbnail'>
                                            <img src='${data.contentObject[i].displayImageOnBlogPage}' alt='Article Image'>
                                        </div>
                                        <div class='content no-after'>
                                            <div class="hero-categories">
                                                <div class="category" style="background:${data.contentObject[i].catColor}">${data.contentObject[i].categoryLinkOnBlogPage} </div>
                                            </div>
                                            <h2 class='title font-fam-LibreBold'>${data.contentObject[i].displayHeadingOnBlogPage}</h2>
                                            <div class='summary'>${data.contentObject[i].displaySummaryOnBlogPage}
                                            <div class='read-article'>
                                                ${Resources.READ_ARTICLE}
                                                <img src='${Urls.rightArrow}' />
                                            </div>
                                        </div>
                                    </div>
                                    `).appendTo('#ajaxFolderContentData');
                                }
                                $('#ajaxFolderContentData').css("display", "flex");
                                $('#allTopicTile').css("display", "none");
                                $('.all-topic-tile-wrapper-heading').css("display", "none");
                            }
                            else{
                                $('#ajaxFolderContentData').empty();
                            }
                        },
                        error: function (data) {
                            $('#ajaxFolderContentData').empty();
                        },
                    })
                }
                e.stopPropagation();
            });
            // Topics List on Blog Page-----end
        })
        /* Mini Nav JS */
        $(document).ready(() =>{
            var H2Tags = getAllH2Tags($(window).width() > 767);
            var $blogMiniNav = $('#blog-mini-nav');
            var $headerScrollOffset = $('.header-banner').outerHeight();
            var $caraousels = $('.experience-layouts-fullscreenstepslider');
            var $blogNavTitle = $("#blog-nav-current-title");
            var $H2Keys = Object.keys(H2Tags);
            $blogNavTitle.text(H2Tags[0]);

            $(window).on('scroll', function () {
                //adjust nav posotion
                if ($('body').height() >= 800) {
                    if ($(window).scrollTop() > $headerScrollOffset) {
                        if ($(window).width() > 767) {
                            $($blogMiniNav).css({
                                'position':'fixed',
                                'top': '77px',
                            });
                        } else {
                            let top = '65px';
                            let key = $(window).scrollTop() ;
                            $caraousels.each((idx,carousel) => {
                                if(key > $(carousel).offset().top - 5 && key < $(carousel).offset().top +$(carousel).outerHeight() + 5){
                                    top = '16px';
                                }
                            })
                            
                            $($blogMiniNav).css({
                                'position':'fixed',
                                'top':top,
                            });
                        }
                    } else {
                        $($blogMiniNav).css({
                            'position':'absolute',
                            'top': '',
                        });
                    }   
                }

                //adding h1 tags 
                let key = Math.floor($(window).scrollTop());
                $H2Keys.forEach(h2 => {
                    if(key - h2 > 0){
                        $("#back-btn-blog-nav").attr("data-href", $blogNavTitle.attr('data-href'));
                        $blogNavTitle.text(H2Tags[h2]);
                        $blogNavTitle.attr("data-href",h2);
                    }
                })
            });

            //adding back links
            $(document).on('click', '#back-btn-blog-nav', function (e) {
                e.stopPropagation();
                var readHref = parseInt($(this).attr('data-href'));
                if (readHref !== '') {
                    if ($(window).width() > 767) {
                        window.scrollTo({
                            top: readHref - 90,
                            left: 0,
                            behavior: "smooth",
                        });
                    }
                    else{
                        readHref += 20;
                        window.scrollTo({
                            top: readHref,
                            left: 0,
                            behavior: "smooth",
                        });
                    }
                    
                }
            });

            //toggle social modal
            $(document).on('click', '#share-article-btn', function (e) {
                e.stopPropagation();
                $(this).children('#blog-social-sharing-modal').eq(0).toggle();
            });

            var divToHide = $('#blog-social-sharing-modal');
            
            $(document).on('click',function(e) {
                if (!$(e.target).is(divToHide)) {
                    divToHide.hide();
                }
            });

            //add share hyperlinks
            let currentLoc = window.location.href
            let title = divToHide.attr("data-title");
            divToHide.children(".blog-share-icons").eq(0).children().each((idx,icon) => {
                switch ($(icon).attr("data-share")) {
                    case "facebook":
                        $(icon).attr("href",`https://www.facebook.com/sharer/sharer.php?u=${currentLoc}`)
                        break;
                    case "twitter":
                        $(icon).attr("href",`https://twitter.com/intent/tweet/?url=${currentLoc}&text=${title}`)
                        break;
                    case "instagram":
                        $(icon).attr("href",`https://www.instagram.com/shiseido/`)
                        break;
                    case "pinterest":
                            $(icon).attr("href",`https://www.pinterest.com/pin/create/button/?url=${currentLoc}&description=${title}`)
                            break;
                    default:
                        break;
                }
            });
            /* Mini Nav End */

            // /**
            //  * Binds events for video player
            //  */
            function playVideoHandler() {
                 //load youtube iframe api
                var tag = document.createElement('script');

                tag.async = true;
                tag.src = 'https://www.youtube.com/iframe_api';

                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                var MAIN_VIDEO_SELECTOR = '.main-video';
                $(document)
                    // main video (inline)
                    .on('click', MAIN_VIDEO_SELECTOR, function () {
                        var $this = $(this);

                        var $inlineEle = $this.parent('div'),
                            videoId = $this.data('video-id');

                        blogPages.playInline($inlineEle, videoId);
                    })
                    .on('keydown', MAIN_VIDEO_SELECTOR, function (e) {
                        if (e.keyCode === 13 || e.keyCode === 32) {
                            var $this = $(this);

                            var $inlineEle = $this.parent('div'),
                                videoId = $this.data('video-id');
                                blogPages.playInline($inlineEle, videoId);
                        }
                    });
            }
            playVideoHandler();
        
        });
        function toggleTopicsRowSlick(makeSlick) {
            if (makeSlick) {
                $(".topics-page-wrapper .topics-wrapper .topics-row").slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToScroll: 1,
                    variableWidth: true,
                    arrows: false,
                });
            }
            else {
                $('.topics-page-wrapper .topics-wrapper .topics-row').slick('unslick');
            }

        }
    },
    playInline: function ($ele, videoId) {
        var eleId = $ele.attr('id');
        if (!eleId || !videoId) { return; }

        new YT.Player(eleId, {
            videoId: videoId,
            width: $ele.width(),
            height: $ele.height(),
            playerVars: {rel: 0},
            events: {
                onReady: function (evt) {
                    var player = evt.target;
                    player.playVideo();
                }
            }
        })
    }
};
export default blogPages;
